document.addEventListener("DOMContentLoaded", () => {
  const SELECTOR = "shop-pay-wallet-button, shopify-accelerated-checkout";
  const MQ = window.matchMedia("(max-width: 767px)");

  function applyHeights(el) {
    const h = MQ.matches ? "40px" : "61px";
    el.style.setProperty("--gravity-button-height", h);
    el.style.setProperty("--gravity-button-min-height", h);
    el.style.setProperty("--shopify-accelerated-checkout-button-block-size", h);
    el.style.display = "block";
    el.style.width = "100%";
  }

  function scanAndApply() {
    document.querySelectorAll(SELECTOR).forEach(applyHeights);
  }

  scanAndApply();

  if (MQ.addEventListener) MQ.addEventListener("change", scanAndApply);
  else MQ.addListener(scanAndApply);

  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches && node.matches(SELECTOR)) applyHeights(node);
        node.querySelectorAll?.(SELECTOR).forEach(applyHeights);
      });
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
});

(() => {
  const STYLE_ID = "installments-custom-style";

  function findAllOpenShadowHosts() {
    const hosts = [];
    const all = document.querySelectorAll("*");
    all.forEach((el) => {
      if (el.shadowRoot) hosts.push(el);
    });
    return hosts;
  }

  function installStyleInShadow(sr) {
    if (!sr || sr.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      #shopify-installments,
      .shopify-payment-terms,
      #shopify-installments-content {
        color: #949494 !important;
        text-align: center !important;
        font-family: Poppins, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif !important;
        font-size: 12px !important;
        font-style: normal !important;
        font-weight: 400 !important;
        line-height: 14px !important;
        justify-self: right;
        @media (max-width: 749px) {
        font-size: 10px !important;
        }
      }

      .font-bold{
      font-weight: 400 !important;
      }
    `;
    sr.appendChild(style);
  }

  function patchShadowIfHasInstallments(host) {
    const sr = host.shadowRoot;
    if (!sr) return false;
    const hasInstallments = sr.querySelector(
      '#shopify-installments, [data-testid="shopify-installments"]'
    );
    if (!hasInstallments) return false;

    installStyleInShadow(sr);

    const mo = new MutationObserver(() => {
      installStyleInShadow(sr);
    });
    mo.observe(sr, { childList: true, subtree: true });
    return true;
  }

  function run() {
    let patched = false;
    document
      .querySelectorAll(
        "shop-pay-wallet-button, shopify-accelerated-checkout, shopify-payment-terms, shopify-installments, shopify-buy-it-now-button"
      )
      .forEach((host) => {
        if (patchShadowIfHasInstallments(host)) patched = true;
      });

    if (!patched) {
      findAllOpenShadowHosts().forEach((host) => {
        patchShadowIfHasInstallments(host);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);
  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  let tries = 0;
  const iv = setInterval(() => {
    run();
    if (++tries > 20) clearInterval(iv);
  }, 250);
})();

(() => {
  const NEW_TEXT = "Shop Now";

  function patchOne(sr) {
    const btn = sr.querySelector("#shopify-installments-cta");
    if (!btn) return false;
    if (btn.textContent.trim() !== NEW_TEXT) {
      btn.textContent = NEW_TEXT;
      btn.setAttribute("aria-label", NEW_TEXT);
    }
    return true;
  }

  function run() {
    let changed = false;
    document.querySelectorAll("*").forEach((el) => {
      if (el.shadowRoot) {
        if (patchOne(el.shadowRoot)) changed = true;
      }
    });
    return changed;
  }

  document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);
  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

(() => {
  const LABEL = "";
  const RATING_SELECTORS = [
    '.bv_avgRating_component_container[itemprop="ratingValue"]',
    '[itemprop="ratingValue"].bv_avgRating_component_container',
    '.bv_stars_component_container [itemprop="ratingValue"]',
    '.bv-summary .bv-rating [itemprop="ratingValue"]',
  ];
  const COUNT_SELECTORS = [
    '.bv_numReviews_component_container [itemprop="reviewCount"]',
    ".bv_numReviews_component_container",
    '[itemprop="reviewCount"]',
  ];

  const markAttr = "data-bv-reviews-appended";

  // Inject CSS to permanently hide BV review counters
  function injectHidingCSS() {
    if (document.getElementById('bv-hide-reviews-css')) return;

    const style = document.createElement('style');
    style.id = 'bv-hide-reviews-css';
    style.textContent = `
      .bv_numReviews_component_container,
      .bv_numReviews_component_container [itemprop="reviewCount"],
      [itemprop="reviewCount"].bv_numReviews_text {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        height: 0 !important;
        width: 0 !important;
        overflow: hidden !important;
        position: absolute !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Inject CSS immediately
  injectHidingCSS();

  function getText(el) {
    return (el && (el.textContent || "").trim()) || "";
  }

  function findFirst(root, sels) {
    for (const sel of sels) {
      const el = root.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function parseCount(text) {
    const m = (text || "").replace(/[,.\s]/g, " ").match(/\d+/);
    return m ? m[0] : "";
  }

  function upsertLabel(ratingEl) {
    if (!ratingEl) return;

    // Check if label already exists next to this element
    let next = ratingEl.nextElementSibling;
    let existingLabel = null;

    // Find existing label if it exists
    if (next && next.classList && next.classList.contains("bv-rating-reviews")) {
      existingLabel = next;
    }

    // Get the rating value from this element (4.5, 5.0, etc)
    const rating = getText(ratingEl);

    const root =
      ratingEl.closest(
        ".bv_main_container, .bv_summary, .bv_stars_component_container, body"
      ) || document;

    // Find count element to hide it
    const countEl = findFirst(root, COUNT_SELECTORS);

    // Hide the original BV reviews count permanently
    if (countEl && countEl.parentElement) {
      const container = countEl.closest('.bv_numReviews_component_container');
      if (container) {
        container.style.display = 'none';
        container.style.visibility = 'hidden';
        container.setAttribute('aria-hidden', 'true');
      } else if (countEl) {
        countEl.style.display = 'none';
        countEl.style.visibility = 'hidden';
        countEl.setAttribute('aria-hidden', 'true');
      }
    }

    // Build the label text - ALWAYS use "Overall Rating" with rating value
    const labelReviews = "(" + document.querySelectorAll('.bv_numReviews_component_container [itemprop="reviewCount"]')[0].getAttribute('content') + " Reviews)"
    const labelText = rating ? ` ${LABEL} ${rating} ${labelReviews}` : ` ${LABEL} ${labelReviews}`;

    // Update existing label or create new one
    if (existingLabel) {
      // Update existing label if text changed
      if (existingLabel.textContent !== labelText) {
        existingLabel.textContent = labelText;
      }
    } else {
      // Create new label
      const span = document.createElement("span");
      span.className = "bv-rating-reviews";
      span.setAttribute(markAttr, "1");
      span.style.cssText = 'display: inline-block !important; visibility: visible !important;';
      span.textContent = labelText + labelReviews;

      ratingEl.insertAdjacentElement("afterend", span);
    }

    // Mark this element as processed
    ratingEl.setAttribute(markAttr, "1");
  }

  function hideOriginalCounters(context = document) {
    // Hide all original BV review count containers
    COUNT_SELECTORS.forEach((sel) => {
      context.querySelectorAll(sel).forEach((el) => {
        const container = el.closest('.bv_numReviews_component_container');
        if (container && !container.hasAttribute('data-bv-hidden')) {
          container.style.display = 'none';
          container.style.visibility = 'hidden';
          container.setAttribute('aria-hidden', 'true');
          container.setAttribute('data-bv-hidden', '1');
        } else if (el && !el.hasAttribute('data-bv-hidden')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.setAttribute('aria-hidden', 'true');
          el.setAttribute('data-bv-hidden', '1');
        }
      });
    });
  }

  function inject(context = document) {
    const seen = new Set();
    RATING_SELECTORS.forEach((sel) => {
      context.querySelectorAll(sel).forEach((el) => {
        if (seen.has(el)) return;
        seen.add(el);
        upsertLabel(el);
      });
    });
    hideOriginalCounters(context);
  }

  document.addEventListener("DOMContentLoaded", () => inject());

  // More aggressive MutationObserver that watches for text changes too
  const mo = new MutationObserver(() => {
    inject(document);
    hideOriginalCounters(document);
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,  // Watch for text changes
    characterDataOldValue: true
  });

  // Run indefinitely with a slower interval after initial burst
  let tries = 0;
  const iv = setInterval(() => {
    inject();
    hideOriginalCounters(document);

    // After 50 tries (12.5 seconds), slow down to every 1 second
    if (tries === 50) {
      clearInterval(iv);
      setInterval(() => {
        inject();
        hideOriginalCounters(document);
      }, 1000);
    }
    tries++;
  }, 250);
})();

(() => {
  const BV_ZONE = [
    ".bv_main_container",
    ".bv_summary",
    ".bv-stars-container",
    ".bv_stars_component_container",
    ".bv_avgRating_component_container",
    ".bv_numReviews_component_container",
  ].join(", ");

  const stopHover = (e) => {
    const t = e.target;
    if (t && t.closest && t.closest(BV_ZONE)) {
      e.stopImmediatePropagation?.();
      e.stopPropagation();
    }
  };

  [
    "pointerover",
    "pointerenter",
    "mouseover",
    "mouseenter",
    "mousemove",
  ].forEach((evt) => document.addEventListener(evt, stopHover, true));

  document.addEventListener("focusin", stopHover, true);

  const style = document.createElement("style");
  style.textContent = `
    [role="tooltip"], .bv-popover, .bv-hover, .bv-tooltip { display: none !important; }
  `;
  document.head.appendChild(style);
})();

(() => {
  const MARK_CLASS = "bv-rating-reviews";
  const RATING_SEL = [
    '.bv_avgRating_component_container[itemprop="ratingValue"]',
    '[itemprop="ratingValue"].bv_avgRating_component_container',
    '.bv_stars_component_container [itemprop="ratingValue"]',
    '.bv-summary .bv-rating [itemprop="ratingValue"]',
  ].join(", ");

  function ensureLabel() {
    document.querySelectorAll(RATING_SEL).forEach((el) => {
      const next = el.nextElementSibling;
      if (!next || !next.classList || !next.classList.contains(MARK_CLASS)) {
        const ratingText = (el.textContent || "").trim();
        if (!ratingText) return;
        const span = document.createElement("span");
        span.className = MARK_CLASS;
        span.style.marginLeft = ".25rem";
        span.style.opacity = ".85";
        span.style.fontSize = ".9em";
        span.style.whiteSpace = "nowrap";
        span.textContent = ` (${ratingText} Reviews)`;
        el.insertAdjacentElement("afterend", span);
      }
    });
  }

  const mo = new MutationObserver(() => ensureLabel());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const BV_ZONE =
    ".bv_stars_component_container, .bv_avgRating_component_container, .bv_numReviews_component_container, .bv_summary, .bv_main_container";

  const stopHover = (e) => {
    if (e.target?.closest?.(BV_ZONE)) {
      e.stopImmediatePropagation?.();
      e.stopPropagation();
    }
  };

  [
    "pointerover",
    "pointerenter",
    "mouseover",
    "mouseenter",
    "mousemove",
  ].forEach((evt) => document.addEventListener(evt, stopHover, true));
})();
